import { sidebarOptions, type TSidebarOption } from "@/zapi-frontend/stores/projectSidebarStore";

type TChapterToolsInput = {
  isTemplateLess: boolean;
  isLabs: boolean;
  chapterSlug?: string;
  commentCount: number;
};

export type TChapterTool = TSidebarOption & { count?: number };

export function getChapterTools({ isTemplateLess, isLabs, chapterSlug, commentCount }: TChapterToolsInput) {
  const isAppendix = !!chapterSlug?.startsWith("appendix-");
  return sidebarOptions
    .filter((option) => !isTemplateLess || option.value === "comments")
    .filter((option) => !option.isLabs || isLabs)
    .filter((option) => !isAppendix || (option.value !== "analysis" && option.value !== "intelligence-questions"))
    .map(
      (option): TChapterTool =>
        option.value === "comments" && commentCount > 0 ? { ...option, count: commentCount } : option
    );
}
